import React, { Component } from "react";
import { Row, Col, Form } from "react-bootstrap";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import CardLessDataTable from '../../datatables/CardLessDataTableWithSearch';
import { entryBranchDefault, scopeBranches, onBranchScopeChange } from "../../../../utils/branchScope";
import { attachModuleGuard, AccessDeniedModal } from "../../../../utils/moduleGuard";

// /Fee-Structure/* → "Fee_Structure". Match on module_key only.
// This tab creates/assigns fee structures. Its handleDeleteRow only removes a row from
// the in-memory draft before submit — it is NOT a server delete, so it stays ungated.
const FEE_STRUCTURE_MODULE = ["Fee_Structure"];

// ─── GraphQL ────────────────────────────────────────────────────────────────
const GET_BRANCHES = gql`
    query getBranches($institution_id: Int!) {
        getBranches(institution_id: $institution_id) {
            id
            branch_name
            sections {
                id
                class_id
                section_name
            }
        }
    }
`;

const ADD_FEE_STRUCTURE = gql`
    mutation($params: StudentFeeStructure) {
        addStudentFeeStructure(params: $params)
    }
`;

const GET_ACADEMIC_YEARS = gql`
    query getAcademicYears($id: Int) {
        getAcademicYears(id: $id) {
            id
            academic_year
        }
    }
`;

const GET_CLASSES = gql`
    query($id: Int) {
        getExamClasses(id: $id) {
            id
            class
        }
    }
`;

const GET_FEE_TYPES = gql`
    query($institute_id: Int) {
        getFeeTypes(institute_id: $institute_id) {
            id
            fee_type_name
            is_report
        }
    }
`;

const GET_CLASS_WISE_FEE_DATA = gql`
    query($institute_id: Int, $branch_ids: [Int], $academic_year_id: Int) {
        getClassWiseFeeData(
            institute_id: $institute_id
            branch_ids: $branch_ids
            academic_year_id: $academic_year_id
        ) {
            branch_id
            branch_name
            class_id
            class_name
            fee_type_id
            fee_type_name
            academic_year_id
            academic_year
            fee
            no_of_terms
            term_dates
        }
    }
`;

const SAMPLE_FEE_DATA = [];

// ── Checkbox Dropdown ────────────────────────────────────────────────────────
class CheckboxDropdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = { open: false };
        this.ref = React.createRef();
    }
    componentDidMount()    { document.addEventListener("mousedown", this.handleOutside); }
    componentWillUnmount() { document.removeEventListener("mousedown", this.handleOutside); }
    handleOutside = (e) => {
        if (this.ref.current && !this.ref.current.contains(e.target))
            this.setState({ open: false });
    };
    toggle = (id) => {
        const { value, onChange } = this.props;
        const exists = value.includes(id);
        onChange(exists ? value.filter((v) => v !== id) : [...value, id]);
    };
    render() {
        const { options, value, placeholder, onChange } = this.props;
        const { open } = this.state;
        const label = value.length === 0
            ? placeholder
            : value.length === options.length
                ? `All (${options.length})`
                : value.length === 1
                    ? options.find((o) => o.value === value[0])?.label || `${value.length} selected`
                    : `${value.length} selected`;
        return (
            <div ref={this.ref} style={{ position: "relative" }}>
                <div onClick={() => this.setState({ open: !open })}
                    style={{ borderRadius: 10, border: "1.5px solid #e5e7eb", padding: "9px 14px", fontSize: 14, color: value.length ? "#1f2937" : "#9ca3af", background: "#f9fafb", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", userSelect: "none" }}>
                    <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{label}</span>
                    <i className={`fal fa-chevron-${open ? "up" : "down"}`} style={{ fontSize: 11, color: "#9ca3af", flexShrink: 0, marginLeft: 6 }} />
                </div>
                {open && (
                    <div style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, background: "#fff", border: "1.5px solid #e5e7eb", borderRadius: 10, boxShadow: "0 8px 24px rgba(0,0,0,0.10)", zIndex: 9999, maxHeight: 220, overflowY: "auto" }}>
                        {options.length === 0 ? (
                            <div style={{ padding: "10px 14px", fontSize: 12, color: "#9ca3af" }}>No options</div>
                        ) : (
                            <>
                                <div onClick={() => onChange(value.length === options.length ? [] : options.map((o) => o.value))}
                                    style={{ padding: "8px 12px", fontSize: 12, fontWeight: 700, color: "#6366f1", cursor: "pointer", borderBottom: "1px solid #f3f4f6", display: "flex", alignItems: "center", gap: 8 }}>
                                    <input type="checkbox" readOnly checked={value.length === options.length} style={{ accentColor: "#6366f1" }} />
                                    Select All
                                </div>
                                {options.map((o) => (
                                    <div key={o.value} onClick={() => this.toggle(o.value)}
                                        style={{ padding: "7px 12px", fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", gap: 8, background: value.includes(o.value) ? "#f5f3ff" : "transparent", borderBottom: "1px solid #f9fafb" }}>
                                        <input type="checkbox" readOnly checked={value.includes(o.value)} style={{ accentColor: "#6366f1" }} />
                                        <span style={{ color: value.includes(o.value) ? "#6d28d9" : "#374151", fontWeight: value.includes(o.value) ? 600 : 400 }}>{o.label}</span>
                                    </div>
                                ))}
                            </>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

class FeeSetupSection extends Component {
    constructor(props) {
        super(props);

        this.state = {
            branch: entryBranchDefault(""),
            branchError: "",

            year: "",
            yearError: "",

            class: "",
            classError: "",

            submitError: "",
            successMessage: "",
            loadingSpinner: false,
            loader: false,
            showAddModal: false,
            assignToAll: false,
            createdFeeTypeIds: [],
            accessDeniedShow: false,

            getClasses: [],
            branches: [],
            branchSections: [],
            feeTypes: [],

            getClassWiseFeeData: [],

            filterBranch: [],
            filterYear: "",
            filterClass: [],
            filterFeeType: [],

            feeRows: [
                {
                    feeType: "",
                    feeTypeId: "",
                    amount: "",
                    terms: "",
                    termDates: [],
                    feeTypeError: "",
                    amountError: "",
                    termsError: "",
                    termDatesError: "",
                },
            ],
        };

        this.guard = attachModuleGuard(this, FEE_STRUCTURE_MODULE);
    }

    // Convert a YYYY-MM-DD input value to a unix-second string (local midnight) for storage,
    // matching the term_date format used elsewhere (student_fee_payments.term_date).
    toUnixDate = (d) => (d ? Math.floor(new Date(`${d}T00:00:00`).getTime() / 1000).toString() : "");

    // Convert a stored unix-second string back to YYYY-MM-DD for the date inputs.
    fromUnixDate = (u) => {
        const n = parseInt(u);
        if (!n || isNaN(n)) return "";
        const dt = new Date(n * 1000);
        const pad = (x) => String(x).padStart(2, "0");
        return `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())}`;
    };

    // Parse the comma-separated term_dates column into an array of YYYY-MM-DD strings.
    parseTermDates = (str) => (str ? String(str).split(",").map((u) => this.fromUnixDate(u.trim())) : []);

    componentDidMount() {
        if (!document.getElementById("fee-shimmer-style")) {
            const style = document.createElement("style");
            style.id = "fee-shimmer-style";
            style.textContent = `
                @keyframes feeShimmer {
                    0%   { background-position: -600px 0; }
                    100% { background-position:  600px 0; }
                }
                .fee-shimmer {
                    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
                    background-size: 1200px 100%;
                    animation: feeShimmer 1.4s infinite linear;
                    border-radius: 8px;
                }
            `;
            document.head.appendChild(style);
        }
        this.getBranches();
        this.getClasses();
        this.getFeeTypes();
        // Branch scope lives in the header (NavbarOne); re-scope on change.
        this.offBranchScope = onBranchScopeChange(() => this.getBranches());
    }

    componentWillUnmount() {
        if (this.offBranchScope) this.offBranchScope();
    }

    componentDidUpdate() {
        const academicYears = this.props.getAcademicYearsQuery?.getAcademicYears || [];
        if (academicYears.length === 0) return;

        const firstId = academicYears[0].id;
        const needsFilterYear = !this.state.filterYear;
        const needsYear       = !this.state.year;

        if (needsFilterYear || needsYear) {
            this.setState({
                ...(needsFilterYear ? { filterYear: firstId } : {}),
                ...(needsYear       ? { year: firstId }       : {}),
            }, () => {
                if (needsFilterYear) this.getClassWiseFeeData();
            });
        }
    }

    getBranches = async () => {
        this.setState({ loader: true });

        try {
            const result = await this.props.client.query({
                query: GET_BRANCHES,
                variables: {
                    institution_id: parseInt(
                        Cookies.get("institutionid")
                    ),
                },
                fetchPolicy: "network-only",
            });

            // Narrowed to the header's branch selection: it drives the list below AND
            // the options offered by the (data-entry) branch select in the fee form.
            const branches = scopeBranches(result.data.getBranches || []);
            const allBranchClassIds = Array.from(new Set(branches.flatMap(b => b.sections || []).map(s => s.class_id)));
            this.setState(
                { branches, filterBranch: branches.map(b => b.id), filterClass: allBranchClassIds, loader: false },
                () => { if (this.state.filterYear) this.getClassWiseFeeData(); }
            );
        } catch {
            this.setState({ loader: false });
        }
    };

    getClassWiseFeeData = async () => {
        this.setState({ loader: true });

        try {
            const result = await this.props.client.query({
                query: GET_CLASS_WISE_FEE_DATA,
                variables: {
                    institute_id: parseInt(Cookies.get("institutionid")),
                    branch_ids: this.state.filterBranch.length > 0 ? this.state.filterBranch.map(Number) : null,
                    academic_year_id: this.state.filterYear ? parseInt(this.state.filterYear) : undefined,
                },
                fetchPolicy: "network-only",
            });

            this.setState({
                getClassWiseFeeData:
                    result.data.getClassWiseFeeData || [],
                loader: false,
            });
        } catch {
            this.setState({ loader: false });
        }
    };

    Columns() {
        return [
            { dataField: "sno", text: "#", formatter: (cell, row, rowIndex) => rowIndex + 1 },
            { dataField: "academic_year", text: "Year", sort: true },
            { dataField: "branch_name", text: "Branch", sort: true },
            { dataField: "class_name", text: "Class", sort: true },
            { dataField: "fee_type_name", text: "Fee Type" },
            { dataField: "fee", text: "Fees", sort: true },
            { dataField: "no_of_terms", text: "Terms", sort: true },
        ];
    }

    getClasses = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_CLASSES,
                variables: { id: 1 },
                fetchPolicy: "network-only",
            });

            const classes = result.data.getExamClasses || [];
            this.setState({ getClasses: classes });
        } catch {
            // ignore
        }
    };

    getFeeTypes = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_FEE_TYPES,
                variables: {
                    institute_id: parseInt(
                        Cookies.get("institutionid")
                    ),
                },
                fetchPolicy: "network-only",
            });

            const feeTypes = result.data.getFeeTypes || [];
            this.setState({ feeTypes, filterFeeType: feeTypes.map(f => f.id) });
        } catch {
            // ignore
        }
    };

    loadExistingFeeRows = async (year, branch, cls) => {
        const feeQuery = GET_CLASS_WISE_FEE_DATA;
        const academicYears = this.props.getAcademicYearsQuery?.getAcademicYears || [];
        const currentYearObj = academicYears.find(y => String(y.id) === String(year));
        const currentYearIdx = academicYears.indexOf(currentYearObj);
        const prevYearObj    = academicYears[currentYearIdx + 1] || null;

        try {
            const vars = { institute_id: parseInt(Cookies.get("institutionid")), branch_ids: [parseInt(branch)] };

            const [currRes, prevRes] = await Promise.all([
                this.props.client.query({ query: feeQuery, variables: { ...vars, academic_year_id: parseInt(year) }, fetchPolicy: "network-only" }),
                prevYearObj
                    ? this.props.client.query({ query: feeQuery, variables: { ...vars, academic_year_id: parseInt(prevYearObj.id) }, fetchPolicy: "network-only" })
                    : Promise.resolve(null),
            ]);

            const currRows = (currRes.data.getClassWiseFeeData || []).filter(r => Number(r.class_id) === Number(cls));

            // Only one fee type is created at a time, and the dropdown shows only fee types that
            // haven't been created yet for this branch + class + year.
            const createdFeeTypeIds = currRows.map(r => Number(r.fee_type_id));
            this.setState({
                createdFeeTypeIds,
                feeRows: [{ feeType: "", feeTypeId: "", amount: "", terms: "", termDates: [], feeTypeError: "", amountError: "", termsError: "", termDatesError: "" }],
            });
        } catch {
            this.setState({ submitError: "Failed to load existing fee data. Please try again." });
        }
    };

    handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === "year") {
            this.setState({
                year: value,
                yearError: "",
                branch: "",
                branchError: "",
                class: "",
                classError: "",
                submitError: "",
            });
        }

        if (name === "branch") {
            this.setState({
                branch: value,
                branchError: "",
                class: "",
                classError: "",
                submitError: "",
            });
        }

        if (name === "class") {
            this.setState({ class: value, classError: "", submitError: "" }, () => {
                if (value && this.state.year && this.state.branch) {
                    this.loadExistingFeeRows(this.state.year, this.state.branch, value);
                }
            });
        }
    };

    handleRowChange = (index, field, value) => {
        // No. of Terms is limited to a single digit (1-9)
        const nextValue = field === "terms"
            ? (value || "").replace(/\D/g, "").slice(0, 1)
            : value;

        const rows = this.state.feeRows.map((row, i) => {
            if (i !== index) return row;

            const updated = {
                ...row,
                [field]: nextValue,
                [`${field}Error`]: "",
            };

            // Resize the term-date inputs to match the chosen number of terms (keeping any already entered).
            if (field === "terms") {
                const count = parseInt(nextValue) || 0;
                const prev = row.termDates || [];
                updated.termDates = Array.from({ length: count }, (_, k) => prev[k] || "");
                updated.termDatesError = "";
            }

            return updated;
        });

        this.setState({ feeRows: rows });
    };

    handleTermDateChange = (rowIndex, termIndex, value) => {
        const rows = this.state.feeRows.map((row, i) => {
            if (i !== rowIndex) return row;
            const termDates = [...(row.termDates || [])];
            termDates[termIndex] = value;
            return { ...row, termDates, termDatesError: "" };
        });
        this.setState({ feeRows: rows });
    };

    handleAddRow = () => {
        this.setState({
            feeRows: [
                ...this.state.feeRows,
                {
                    feeType: "",
                    feeTypeId: "",
                    amount: "",
                    terms: "",
                    termDates: [],
                    feeTypeError: "",
                    amountError: "",
                    termsError: "",
                    termDatesError: "",
                },
            ],
        });
    };

    handleDeleteRow = (index) => {
        this.setState({
            feeRows: this.state.feeRows.filter(
                (_, i) => i !== index
            ),
        });
    };

    // Last gate before addStudentFeeStructure (create / assign fee) leaves the client.
    handleFormSubmit = async (e) => {
        if (e) e.preventDefault();

        if (!this.guard.requireEdit()) return;


        let hasError = false;
        const fieldErrors = {};

        if (!this.state.branch) {
            fieldErrors.branchError = "Please select a branch";
            hasError = true;
        }

        if (!this.state.year) {
            fieldErrors.yearError = "Please select an academic year";
            hasError = true;
        }

        if (!this.state.class) {
            fieldErrors.classError = "Please select a class";
            hasError = true;
        }

        const validatedRows = this.state.feeRows.map((row) => {
            if (row.isExisting) return row;

            const updated = { ...row };

            if (!row.feeTypeId) {
                updated.feeTypeError =
                    "Please select fee type";
                hasError = true;
            }

            const amt = parseFloat(row.amount);

            if (!row.amount || isNaN(amt) || amt <= 0) {
                updated.amountError =
                    "Please enter a valid amount greater than 0";
                hasError = true;
            }

            const termsVal = parseInt(row.terms);

            if (!row.terms || isNaN(termsVal) || termsVal <= 0) {
                updated.termsError = "Please enter a valid number of terms";
                hasError = true;
            } else {
                // Every term needs a due date selected.
                const dates = row.termDates || [];
                if (dates.length < termsVal || dates.slice(0, termsVal).some((d) => !d)) {
                    updated.termDatesError = "Please select a date for every term";
                    hasError = true;
                }
            }

            return updated;
        });

        if (hasError) {
            this.setState({
                ...fieldErrors,
                feeRows: validatedRows,
            });

            return;
        }

        this.setState({
            loadingSpinner: true,
            submitError: "",
            successMessage: "",
        });

        try {
            const params = {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.branch),
                year_id: parseInt(this.state.year),
                class_id: parseInt(this.state.class),
                assign_to_all: !!this.state.assignToAll,
                fee_details: this.state.feeRows
                    .filter((row) => !row.isExisting)
                    .map((row) => {
                        const termCount = parseInt(row.terms) || 0;
                        return {
                            fee_type_id: parseInt(row.feeTypeId),
                            fee_amount: row.amount.toString(),
                            no_of_terms: termCount,
                            term_dates: (row.termDates || [])
                                .slice(0, termCount)
                                .map((d) => this.toUnixDate(d)),
                        };
                    }),
            };

            await this.props.addStudentFeeStructure({
                variables: { params },
            });

            this.setState({
                loadingSpinner: false,
                successMessage:
                    "Fee data saved successfully",
            });

            setTimeout(() => this.resetForm(), 1500);
        } catch (error) {
            this.setState({
                loadingSpinner: false,
                submitError:
                    error.graphQLErrors
                        ?.map((x) => x.message)
                        .join(", ") ||
                    "Submission failed. Please try again.",
            });
        }
    };

    resetForm = () => {
        this.setState({
            branch: entryBranchDefault(""),
            year: "",
            class: "",

            branchError: "",
            yearError: "",
            classError: "",

            submitError: "",
            successMessage: "",
            loadingSpinner: false,
            showAddModal: false,
            assignToAll: false,
            createdFeeTypeIds: [],

            feeRows: [
                {
                    feeType: "",
                    feeTypeId: "",
                    amount: "",
                    terms: "",
                    termDates: [],
                    feeTypeError: "",
                    amountError: "",
                    termsError: "",
                    termDatesError: "",
                },
            ],
        });

        this.getClassWiseFeeData();
        this.getClasses();
    };

    // Opens the create/assign fee-structure modal. Gated before it appears; the submit
    // re-checks at the write. Button stays visible and clickable.
    openAddModal = () => {
        if (!this.guard.requireEdit()) return;

        this.setState({
            showAddModal: true,
            branch: entryBranchDefault(""), year: "", class: "",
            branchError: "", yearError: "", classError: "",
            submitError: "", successMessage: "", assignToAll: false, createdFeeTypeIds: [],
            feeRows: [
                { feeType: "", feeTypeId: "", amount: "", terms: "", termDates: [], feeTypeError: "", amountError: "", termsError: "", termDatesError: "" },
            ],
        });
    };

    closeAddModal = () => {
        this.setState({ showAddModal: false, submitError: "", successMessage: "" });
    };

    render() {

        const {
            branch,
            branchError,

            year,
            yearError,

            class: cls,
            classError,

            submitError,
            successMessage,
            loadingSpinner,

            feeRows,
            feeTypes,

            getClassWiseFeeData,
            loader,

            filterBranch,
            filterYear,
            filterClass,
            filterFeeType,

            getClasses,
        } = this.state;

        const academicYears =
            this.props.getAcademicYearsQuery?.getAcademicYears || [];

        const branchClassIds = branch
            ? new Set((this.state.branches.find(b => b.id == branch)?.sections || []).map(s => s.class_id))
            : null;
        const filteredClasses = branchClassIds
            ? getClasses.filter(c => branchClassIds.has(c.id))
            : getClasses;

        // Fee types still available to create for the selected branch + class + year.
        const createdIds = (this.state.createdFeeTypeIds || []).map(Number);
        const availableFeeTypes = (feeTypes || []).filter(ft => !createdIds.includes(Number(ft.id)));

        const tableData =
            getClassWiseFeeData.length > 0
                ? getClassWiseFeeData
                : SAMPLE_FEE_DATA;

        let filteredData = tableData;

        if (filterClass.length > 0)
            filteredData = filteredData.filter(d => filterClass.map(Number).includes(Number(d.class_id)));

        if (filterFeeType.length > 0)
            filteredData = filteredData.filter(d => filterFeeType.map(Number).includes(Number(d.fee_type_id)));

        const S = {
            page: { padding: "8px 0" },

            card: {
                background: "#fff",
                borderRadius: 20,
                boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
                marginBottom: 24,
                overflow: "hidden",
            },

            cardHeader: {
                background: "#ffffff",
                padding: "20px 24px",
                display: "flex",
                alignItems: "center",
                gap: 14,
                borderBottom: "1px solid #f1f5f9",
            },

            iconWrapperCreate: {
                width: 38,
                height: 38,
                borderRadius: 10,
                background: "#e0e7ff",
                border: "1px solid #c7d2fe",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#4f46e5",
                fontSize: 16,
                flexShrink: 0,
            },

            iconWrapperList: {
                width: 38,
                height: 38,
                borderRadius: 10,
                background: "#f5f3ff",
                border: "1px solid #ddd6fe",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#7c3aed",
                fontSize: 16,
                flexShrink: 0,
            },

            cardTitleText: {
                display: "flex",
                flexDirection: "column",
                textAlign: "left",
            },

            cardTitle: {
                color: "#0f172a",
                fontWeight: 700,
                fontSize: 16,
                margin: 0,
                letterSpacing: "-0.01em",
            },

            cardSubtitle: {
                color: "#64748b",
                fontSize: 12,
                fontWeight: 500,
                marginTop: 2,
            },

            cardBody: {
                padding: "22px 24px",
            },

            label: {
                fontSize: 12,
                fontWeight: 600,
                color: "#6b7280",
                marginBottom: 6,
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                display: "block",
            },

            input: {
                borderRadius: 10,
                border: "1.5px solid #e5e7eb",
                padding: "9px 14px",
                fontSize: 14,
                color: "#1f2937",
                background: "#f9fafb",
                width: "100%",
            },

            inputError: {
                borderRadius: 10,
                border: "1.5px solid #ef4444",
                padding: "9px 14px",
                fontSize: 14,
                color: "#1f2937",
                background: "#f9fafb",
                width: "100%",
            },

            inputDisabled: {
                borderRadius: 10,
                border: "1.5px solid #e5e7eb",
                padding: "9px 14px",
                fontSize: 14,
                color: "#9ca3af",
                background: "#f3f4f6",
                width: "100%",
            },

            addBtn: {
                background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                border: "none",
                borderRadius: 10,
                padding: "9px 28px",
                fontWeight: 700,
                fontSize: 14,
                color: "#fff",
                boxShadow: "0 4px 12px rgba(16,185,129,0.3)",
                cursor: "pointer",
            },

            countChip: {
                background: "#f5f3ff",
                color: "#7c3aed",
                borderRadius: 20,
                padding: "4px 12px",
                fontWeight: 600,
                fontSize: 12,
                border: "1px solid #ddd6fe",
                marginLeft: "auto",
            },
        };

        return (
            <div style={S.page}>

                {/* Create Fee Modal */}
                {this.state.showAddModal && (
                <div style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", background: "rgba(0,0,0,0.3)", zIndex: 9999, display: "flex", alignItems: "flex-start", justifyContent: "center", overflowY: "auto", padding: "40px 16px" }}>
                <div style={{ background: "#fff", borderRadius: 16, boxShadow: "0 2px 16px rgba(0,0,0,0.15)", width: "100%", maxWidth: 760 }}>
                    <div style={S.cardHeader}>
                        <div style={S.iconWrapperCreate}>
                            <i className="fal fa-plus-circle" />
                        </div>
                        <div style={S.cardTitleText}>
                            <h5 style={S.cardTitle}>Create Fee</h5>
                            <span style={S.cardSubtitle}>Set up academic year-wise fee structures for classes</span>
                        </div>
                        <button type="button" onClick={this.closeAddModal} style={{ marginLeft: "auto", background: "none", border: "none", fontSize: 22, lineHeight: 1, color: "#94a3b8", cursor: "pointer" }}>&times;</button>
                    </div>

                    <div style={S.cardBody}>
                        <Form onSubmit={this.handleFormSubmit}>

                            <Row className="g-3">

                                <Col md={4}>
                                    <label style={S.label}>Academic Year</label>

                                    <select
                                        name="year"
                                        value={year}
                                        onChange={this.handleInputChange}
                                        style={yearError ? S.inputError : S.input}
                                    >
                                        <option value="">--- Select Year ---</option>
                                        {academicYears.map((y) => (
                                            <option key={y.id} value={y.id}>
                                                {y.academic_year}
                                            </option>
                                        ))}
                                    </select>
                                    {yearError && <div style={{ color: "#ef4444", fontSize: 12, marginTop: 4 }}>{yearError}</div>}
                                </Col>

                                <Col md={4}>
                                    <label style={S.label}>Branch</label>

                                    <select
                                        name="branch"
                                        value={branch}
                                        onChange={this.handleInputChange}
                                        disabled={!year}
                                        style={
                                            branchError
                                                ? S.inputError
                                                : year
                                                ? S.input
                                                : S.inputDisabled
                                        }
                                    >
                                        <option value="">
                                            --- Select Branch ---
                                        </option>

                                        {this.state.branches.map((b) => (
                                            <option key={b.id} value={b.id}>
                                                {b.branch_name}
                                            </option>
                                        ))}
                                    </select>
                                    {branchError && <div style={{ color: "#ef4444", fontSize: 12, marginTop: 4 }}>{branchError}</div>}
                                </Col>

                                <Col md={4}>
                                    <label style={S.label}>Class</label>

                                    <select
                                        name="class"
                                        value={cls}
                                        onChange={this.handleInputChange}
                                        disabled={!year || !branch}
                                        style={
                                            classError
                                                ? S.inputError
                                                : !year || !branch
                                                ? S.inputDisabled
                                                : S.input
                                        }
                                    >
                                        <option value="">
                                            --- Select Class ---
                                        </option>

                                        {filteredClasses.map((c) => (
                                            <option key={c.id} value={c.id}>
                                                {c.class}
                                            </option>
                                        ))}
                                    </select>
                                    {classError && <div style={{ color: "#ef4444", fontSize: 12, marginTop: 4 }}>{classError}</div>}
                                </Col>

                            </Row>

                            {(!year || !branch || !cls) && (
                                <div style={{ marginTop: 24, padding: "14px 16px", background: "#f8fafc", border: "1px dashed #cbd5e1", borderRadius: 10, color: "#64748b", fontSize: 13, textAlign: "center" }}>
                                    Select Academic Year, Branch and Class to add fee types.
                                </div>
                            )}

                            {year && branch && cls && availableFeeTypes.length === 0 && (
                                <div style={{ marginTop: 24, padding: "14px 16px", background: "#fef9c3", border: "1px solid #fde68a", borderRadius: 10, color: "#854d0e", fontSize: 13, textAlign: "center", fontWeight: 600 }}>
                                    All fee types have already been created for this class.
                                </div>
                            )}

                            {year && branch && cls && availableFeeTypes.length > 0 && (<>
                            <div style={{ marginTop: 24 }}>

                                {feeRows.map((row, idx) => (
                                    <React.Fragment key={idx}>
                                    <Row className="mb-2 align-items-end g-2">

                                        <Col lg={4} md={6} sm={12}>
                                            <label style={S.label}>Fee Type</label>
                                            <select
                                                value={row.feeTypeId}
                                                disabled={!!row.isExisting}
                                                onChange={(e) => {
                                                    const selected = feeTypes.find((f) => f.id == e.target.value);
                                                    const rows = feeRows.map((r, i) => i !== idx ? r : {
                                                        ...r,
                                                        feeTypeId: e.target.value,
                                                        feeType: selected?.fee_type_name || "",
                                                        feeTypeError: "",
                                                    });
                                                    this.setState({ feeRows: rows });
                                                }}
                                                style={row.feeTypeError ? S.inputError : row.isExisting ? S.inputDisabled : S.input}
                                            >
                                                <option value="">--- Select Fee Type ---</option>
                                                {feeTypes
                                                    // Show only fee types not already created for this branch + class + year.
                                                    .filter((fee) => fee.id == row.feeTypeId || !(this.state.createdFeeTypeIds || []).map(Number).includes(Number(fee.id)))
                                                    .map((fee) => (
                                                        <option key={fee.id} value={fee.id}>{fee.fee_type_name}</option>
                                                    ))}
                                            </select>
                                            {row.feeTypeError && <div style={{ color: "#ef4444", fontSize: 11, marginTop: 3 }}>{row.feeTypeError}</div>}
                                        </Col>

                                        <Col lg={4} md={6} sm={12}>
                                            <label style={S.label}>Amount (₹)</label>
                                            <input
                                                type="number"
                                                min="1"
                                                placeholder="Enter Amount"
                                                value={row.amount}
                                                disabled={!!row.isExisting}
                                                onChange={(e) => this.handleRowChange(idx, "amount", e.target.value)}
                                                style={row.amountError ? S.inputError : row.isExisting ? S.inputDisabled : S.input}
                                            />
                                            {row.amountError && <div style={{ color: "#ef4444", fontSize: 11, marginTop: 3 }}>{row.amountError}</div>}
                                        </Col>

                                        <Col lg={3} md={6} sm={12}>
                                            <label style={S.label}>No. of Terms</label>
                                            <input
                                                type="number"
                                                min="1"
                                                max="9"
                                                placeholder="Terms"
                                                value={row.terms}
                                                disabled={!!row.isExisting}
                                                onChange={(e) => this.handleRowChange(idx, "terms", e.target.value)}
                                                style={row.termsError ? S.inputError : row.isExisting ? S.inputDisabled : S.input}
                                            />
                                            {row.termsError && <div style={{ color: "#ef4444", fontSize: 11, marginTop: 3 }}>{row.termsError}</div>}
                                        </Col>

                                    </Row>

                                    {parseInt(row.terms) > 0 && (
                                        <Row className="mb-3 g-2" style={{ background: "#f8fafc", borderRadius: 10, padding: "10px 8px", marginLeft: 0, marginRight: 0 }}>
                                            <Col xs={12} style={{ marginBottom: 2 }}>
                                                <label style={{ ...S.label, marginBottom: 0 }}>Term Due Dates</label>
                                            </Col>
                                            {Array.from({ length: parseInt(row.terms) }).map((_, t) => (
                                                <Col key={t} lg={3} md={4} sm={6}>
                                                    <label style={{ ...S.label, fontSize: 11, color: "#64748b" }}>Term {t + 1}</label>
                                                    <input
                                                        type="date"
                                                        value={(row.termDates || [])[t] || ""}
                                                        disabled={!!row.isExisting}
                                                        onChange={(e) => this.handleTermDateChange(idx, t, e.target.value)}
                                                        style={row.isExisting ? S.inputDisabled : (row.termDatesError && !((row.termDates || [])[t]) ? S.inputError : S.input)}
                                                    />
                                                </Col>
                                            ))}
                                            {row.termDatesError && (
                                                <Col xs={12}>
                                                    <div style={{ color: "#ef4444", fontSize: 11, marginTop: 3 }}>{row.termDatesError}</div>
                                                </Col>
                                            )}
                                        </Row>
                                    )}
                                    </React.Fragment>
                                ))}

                            </div>

                            <div style={{ marginTop: 8, padding: "12px 14px", background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 10 }}>
                                <label style={{ display: "flex", alignItems: "flex-start", gap: 10, cursor: "pointer", margin: 0 }}>
                                    <input
                                        type="checkbox"
                                        checked={this.state.assignToAll}
                                        onChange={(e) => this.setState({ assignToAll: e.target.checked })}
                                        style={{ width: 16, height: 16, marginTop: 2, accentColor: "#2563eb" }}
                                    />
                                    <span style={{ fontSize: 13, color: "#1e3a8a" }}>
                                        <strong>Assign to all students</strong> in this branch &amp; class — creates each student's fee record and term schedule (with the dates above).
                                    </span>
                                </label>
                            </div>
                            </>)}

                            {successMessage && (
                                <div
                                    className="mt-3"
                                    style={{
                                        background: "#ecfdf5",
                                        border: "1px solid #6ee7b7",
                                        borderRadius: 10,
                                        padding: "10px 16px",
                                        color: "#065f46",
                                        fontWeight: 600,
                                        fontSize: 14,
                                        textAlign: "center",
                                    }}
                                >
                                    {successMessage}
                                </div>
                            )}

                            {submitError && (
                                <div
                                    className="mt-3"
                                    style={{
                                        background: "#fef2f2",
                                        border: "1px solid #fca5a5",
                                        borderRadius: 10,
                                        padding: "10px 16px",
                                        color: "#991b1b",
                                        fontWeight: 600,
                                        fontSize: 14,
                                        textAlign: "center",
                                    }}
                                >
                                    {submitError}
                                </div>
                            )}

                            <div
                                className="mt-4"
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                {(() => {
                                    const allExisting = feeRows.length > 0 && feeRows.every(r => r.isExisting);
                                    return (
                                        <button
                                            type="submit"
                                            style={{
                                                ...S.addBtn,
                                                opacity: (loadingSpinner || allExisting) ? 0.5 : 1,
                                                cursor: allExisting ? "not-allowed" : "pointer",
                                            }}
                                            disabled={loadingSpinner || allExisting}
                                            title={allExisting ? "All fee types have already been created" : ""}
                                        >
                                            {loadingSpinner ? "Saving..." : allExisting ? "All Fees Created" : "Create"}
                                        </button>
                                    );
                                })()}
                            </div>

                        </Form>
                    </div>
                </div>
                </div>
                )}

                {/* Table Section */}

                {loader ? (
                    <div style={{ background: "#fff", borderRadius: 20, boxShadow: "0 2px 16px rgba(0,0,0,0.07)", overflow: "hidden" }}>
                        {/* Header */}
                        <div style={{ background: "#ffffff", padding: "20px 24px", display: "flex", alignItems: "center", gap: 14, borderBottom: "1px solid #f1f5f9" }}>
                            <div className="fee-shimmer" style={{ width: 38, height: 38, borderRadius: 10, flexShrink: 0 }} />
                            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                                <div className="fee-shimmer" style={{ width: 100, height: 16 }} />
                                <div className="fee-shimmer" style={{ width: 220, height: 11 }} />
                            </div>
                            <div className="fee-shimmer" style={{ width: 70, height: 24, borderRadius: 20, marginLeft: "auto" }} />
                        </div>
                        {/* Filters */}
                        <div style={{ padding: "16px 24px", borderBottom: "1px solid #f3f4f6", display: "flex", gap: 16 }}>
                            {[0, 1, 2, 3].map((i) => (
                                <div key={i} className="fee-shimmer" style={{ flex: 1, height: 40 }} />
                            ))}
                        </div>
                        {/* Table */}
                        <div style={{ padding: "16px 24px" }}>
                            <div style={{ display: "flex", gap: 12, marginBottom: 12 }}>
                                {[80, 120, 100, 130, 90].map((w, i) => (
                                    <div key={i} className="fee-shimmer" style={{ width: w, height: 14 }} />
                                ))}
                            </div>
                            {Array.from({ length: 6 }).map((_, i) => (
                                <div key={i} style={{ display: "flex", gap: 12, marginBottom: 14 }}>
                                    {[80, 120, 100, 130, 90].map((w, j) => (
                                        <div key={j} className="fee-shimmer" style={{ width: w, height: 13, opacity: 1 - i * 0.1 }} />
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>
                ) : (
                    <div style={{ ...S.card, overflow: "visible" }}>

                        <div style={S.cardHeader}>
                            <div style={S.iconWrapperList}>
                                <i className="fal fa-list-alt" />
                            </div>
                            <div style={S.cardTitleText}>
                                <h5 style={S.cardTitle}>Fee List</h5>
                                <span style={S.cardSubtitle}>View and manage configured fee profiles</span>
                            </div>

                            <span style={S.countChip}>
                                {filteredData.length} records
                            </span>
                            <button style={{ ...S.addBtn, marginLeft: 12 }} onClick={this.openAddModal}>
                                <i className="fal fa-plus mr-2" />Create Fee
                            </button>
                        </div>

                        <div
                            style={{
                                padding: "16px 24px",
                                borderBottom: "1px solid #f3f4f6",
                            }}
                        >
                            <Row className="g-2">
                                             <Col md={3}>
                                    <select
                                        value={filterYear}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            this.setState({ filterYear: val }, () => this.getClassWiseFeeData());
                                        }}
                                        style={S.input}
                                    >
                                        {academicYears.map((y) => (
                                            <option
                                                key={y.id}
                                                value={y.id}
                                            >
                                                {y.academic_year}
                                            </option>
                                        ))}
                                    </select>
                                </Col>

                                {/* No Branch filter — the header's branch selection scopes this list. */}

                                <Col md={3}>
                                    <CheckboxDropdown
                                        options={(() => {
                                            if (filterBranch.length === 0) return [];
                                            const ids = new Set(
                                                this.state.branches
                                                    .filter(b => filterBranch.map(Number).includes(Number(b.id)))
                                                    .flatMap(b => b.sections || [])
                                                    .map(s => s.class_id)
                                            );
                                            return getClasses.filter(c => ids.has(c.id)).map(c => ({ value: c.id, label: c.class }));
                                        })()}
                                        value={filterClass}
                                        onChange={(val) => this.setState({ filterClass: val })}
                                        placeholder="All Classes"
                                    />
                                </Col>

                                <Col md={3}>
                                    <CheckboxDropdown
                                        options={feeTypes.map(f => ({ value: f.id, label: f.fee_type_name }))}
                                        value={filterFeeType}
                                        onChange={(val) => this.setState({ filterFeeType: val })}
                                        placeholder="All Fee Types"
                                    />
                                </Col>

                            </Row>
                        </div>

                        <div style={{ padding: "16px 24px" }}>
                            <CardLessDataTable
                                parentData={filteredData}
                                particlecolumns={this.Columns()}
                                search={true}
                                name="fee_setup_list"
                            />
                        </div>

                    </div>
                )}

                {/* Shown instead of opening the create modal / saving the fee structure
                    when is_edit is missing. This tab has no server-side delete. */}
                <AccessDeniedModal
                    show={this.state.accessDeniedShow}
                    onHide={this.guard.hideAccessDenied}
                />

            </div>
        );
    }
}

export default withRouter(
    withApollo(
        compose(
            graphql(ADD_FEE_STRUCTURE, { name: "addStudentFeeStructure" }),
            graphql(GET_ACADEMIC_YEARS, {
                name: "getAcademicYearsQuery",
                options: {
                    variables: { id: 1 },
                },
                fetchPolicy: "network-only",
            })
        )(FeeSetupSection)
    )
);